// ============================================================================
// pushJelzo.js — a push-értesítés "átvétele" a kliensen (2026-10-13, tagi kérés: csak az első változásról szóljon az
// értesítés, utána csend a következő belépésig; az alkalmazás ikonján jelzés, megnyitáskor minden frissüljön).
//
// A MENET: (1) a szerver az első változásról push-t küld, és az eszközt "függőnek" jelöli (functions/src/lib/pushAllapot.js),
// (2) a service worker megjeleníti az értesítést, az alkalmazás ikonjára jelvényt tesz (Badge API), és egy jelzőt ír a
// Cache API-ba, (3) a tag megnyitja az alkalmazást: itt az átvétel - a jelvény törlődik, és ha volt jelző (vagy már régen
// nem vettünk át), a szerver felé is jelezzük (ackPush), így a következő változásról újra szólnak.
// A jelző a Cache API-ban él, mert azt a service worker ÉS a lap is eléri (a localStorage-t a worker nem).
// ============================================================================

export const JELZO_CACHE = "lineage0-push-flag";
export const JELZO_URL = "/__push-flag";
const UTOLSO_ATVETEL_KULCS = "lineage0_push_ack_at";
// Biztonsági háló: ha egy eszközön nincs jelző (pl. a worker nem futott le), legalább naponta egyszer átveszünk -
// különben egy elveszett jelzés után az eszköz végleg néma maradhatna.
export const BIZTONSAGI_ATVETEL_MS = 24 * 3600 * 1000;

/** Kell-e a szerver felé átvételt jelezni? (tiszta döntés - tesztelhető) */
export function kellAtvenni({ jelzo, utolsoAtvetelMs, most }) {
  if (jelzo) return true;
  if (typeof utolsoAtvetelMs !== "number" || !Number.isFinite(utolsoAtvetelMs)) return true;
  return most < utolsoAtvetelMs || most - utolsoAtvetelMs >= BIZTONSAGI_ATVETEL_MS;
}

export async function jelzoVanE(cs = globalThis.caches) {
  try {
    if (!cs || typeof cs.open !== "function") return false;
    const cache = await cs.open(JELZO_CACHE);
    return Boolean(await cache.match(JELZO_URL));
  } catch (e) {
    return false;
  }
}

export async function jelzoTorles(cs = globalThis.caches) {
  try {
    if (!cs || typeof cs.open !== "function") return;
    const cache = await cs.open(JELZO_CACHE);
    await cache.delete(JELZO_URL);
  } catch (e) { /* nem kritikus */ }
}

/** Az alkalmazás ikonjának jelvénye: törlés (megnyitáskor). A Badge API nem mindenhol támogatott - ez nem hiba. */
export async function jelvenyTorles(nav = globalThis.navigator) {
  try {
    if (nav && typeof nav.clearAppBadge === "function") await nav.clearAppBadge();
    else if (nav && typeof nav.setAppBadge === "function") await nav.setAppBadge(0);
  } catch (e) { /* nem kritikus */ }
}

export function utolsoAtvetel(tar = globalThis.localStorage) {
  try {
    const v = Number(tar.getItem(UTOLSO_ATVETEL_KULCS));
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch (e) {
    return null;
  }
}

export function utolsoAtvetelMentese(ms, tar = globalThis.localStorage) {
  try { tar.setItem(UTOLSO_ATVETEL_KULCS, String(ms)); } catch (e) { /* nem kritikus */ }
}

/**
 * Az átvétel: a jelvény törlése és (ha kell) a szerver értesítése.
 * @param {{atvetelFn: () => Promise<any>, kenyszeritett?: boolean, most?: number}} p  atvetelFn = a szerveres ackPush hívás
 * @returns {Promise<boolean>} szóltunk-e a szervernek
 */
export async function pushAtvetel({ atvetelFn, kenyszeritett = false, most = Date.now() }) {
  const jelzo = await jelzoVanE();
  let szoltunk = false;
  if (kenyszeritett || kellAtvenni({ jelzo, utolsoAtvetelMs: utolsoAtvetel(), most })) {
    try {
      await atvetelFn();
      utolsoAtvetelMentese(most);
      await jelzoTorles();
      szoltunk = true;
    } catch (e) { /* a következő megnyitáskor újra próbáljuk */ }
  }
  await jelvenyTorles();
  return szoltunk;
}
